export default{
    __bsi_SeeAll:"ล็อกอินสำหรับดูทั้งหมด"
}